const localizers = {
  'loading.msg': () => `Chargement en cours...`,
  'SASServer.genericError.msg': () => `Le serveur est inaccessible.`,
  'SASReport.genericError.msg': () => `Impossible de charger le rapport sélectionné.`,
  'SASReportImage.genericError.msg': () => `Impossible de charger l’image du rapport.`,
  'SASReportImage.imageNotSupported.msg': () => `Les images ne sont pas prises en charge pour ce type de contenu de rapport.`,
}
export default localizers;
